import { render } from "./show.vue?vue&type=template&id=8592981a&ts=true"
import script from "./show.vue?vue&type=script&lang=ts"
export * from "./show.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__